


























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ThDropdownVue from "../components/ThDropdown.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import { DatePickerOptions } from "element-ui/types/date-picker";
import version from "@/version";

@Component({
    components: {
        "th-dropdown": ThDropdownVue,
        "user-tree": AllUserTreeVue,
    }
})
export default class LogRecord extends Vue {
    accounterNo: string = "";
    allType: string = "";
    currentPage: number = 1;
    totalElements: number = 0;
    size: number = 15;
    tableDate: Log.Log[] = [];
    created(){
        // if(localStorage.getItem("no") !== "01") {
            this.accounterNo = <string>localStorage.getItem("no")
            this.fetchData()
        // } else this.accounterNo = ""
    }
    search: string = ""
    typeList: DataTable.DropItem[] = [
        {
            id: 0,
            text: "全部"
        },
        {
            id: 1,
            text: "指派"
        },
        {
            id: 2,
            text: "结账"
        },
        // {
        //     id: 3,
        //     text: "邮件"
        // },
        {
            id: 4,
            text: "导入"
        },
        {
            id: 5,
            text: "导出"
        },
        {
            id: 6,
            text: "启用"
        },
        {
            id: 7,
            text: "禁用"
        },
        {
            id: 8,
            text: "新建"
        },
        {
            id: 9,
            text: "删除"
        },
        {
            id: 10,
            text: "新建用户"
        },
        {
            id: 11,
            text: "删除用户"
        },
        {
            id: 12,
            text: "登录"
        },
        {
            id: 13,
            text: "恢复"
        },
        // {
        //     id: 14,
        //     text: "彻底删除"
        // }
    ];
    startSearch() {
        this.currentPage = 1;
        this.fetchData();
    }
    chargeStatus: DataTable.DropItem = this.typeList[0];
    accounterName: string = "所属人姓名";
    dateRange: Date[] = [new Date(), new Date()];
    startDay: string = this.$utils.simpleDateFormat(new Date(), "d");
    endDay: string = this.$utils.simpleDateFormat(new Date(), "d");
    pickerOptions: DatePickerOptions = {
        shortcuts: [{
            text: "最近一周",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "最近一个月",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
            }
        }, {
            text: "最近三个月",
            onClick(picker: any) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
            }
        }]
    }
    //选择时间
    changeDate(date: Date[]) {
        this.startDay = this.$utils.simpleDateFormat(date[0], "d");
        this.endDay = this.$utils.simpleDateFormat(date[1], "d");
        this.fetchData();
    }
    // 获取表格数据
    fetchData(no?: string, item?: DataTable.DropItem) {
        if (item) {
            if (item.text) {
                if (item.text === "全部") this.allType = ""
                else this.allType = item.text
            }
        }
        if (no) this.accounterNo = no
        Vue.axios
            .get(
                `operationlog?page=${this.currentPage - 1}&size=${this.size}&accounterNo=${this.accounterNo}&operateType=${this.allType}&startDay=${this.startDay}&endDay=${this.endDay}&search=${this.search}`,
            )
            .then(res => {
                this.tableDate = res.data.content;
                this.totalElements = res.data.totalElements;
            });
    }
    // 分页
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    // 打开tree
    isTree: boolean = false;
    openTree() {
        this.isTree = !this.isTree;
    }
    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    tmp: UserTree | null = null;
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    handleNodeClick(data: Account) {
        if (data.name) this.accounterName = data.name
        this.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.fetchData(data.no);
        this.isTree = false;
    }
    // 关闭tree
    closeTree() {
        this.isTree = false;
    }
    // 导出
    mainDownload() {
        let url = `${Vue.axios.defaults.baseURL}export/operationlog?&token=${this.$store.state.account.token}&version=${version}&accounterNo=${this.accounterNo}&operateType=${this.allType}&startDay=${this.startDay}&endDay=${this.endDay}&search=${this.search}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    changeType(val:any) {
        if(val.id === 0) this.allType = ""
        else this.allType = val.text
        this.fetchData()
    }
}
